export default function imageGallery(element: HTMLElement) {
  const lightboxId = element.dataset.lightboxId;
  if (!lightboxId) {
    console.warn('imageGallery: missing data-lightbox-id attribute');
    return;
  }

  const lightboxElement = document.getElementById(lightboxId);
  if (!lightboxElement) {
    console.warn(
      `imageGallery: lightbox element with id "${lightboxId}" not found`,
    );
    return;
  }

  const galleryItems = element.querySelectorAll('.imageGallery__item');
  const images: Array<{ src: string; alt: string }> = [];

  galleryItems.forEach((item) => {
    if (!(item instanceof HTMLElement)) return;

    const fullImageUrl = item.dataset.fullImageUrl;
    const alt = item.dataset.alt || '';

    if (fullImageUrl) {
      images.push({ src: fullImageUrl, alt });
    }
  });

  galleryItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      // biome-ignore lint/suspicious/noExplicitAny: allow any for lightboxOpen
      if ((lightboxElement as any).lightboxOpen) {
        // biome-ignore lint/suspicious/noExplicitAny: allow any for lightboxOpen
        (lightboxElement as any).lightboxOpen(index, images);
      }
    });
  });
}
